import { css } from "@emotion/react";

export const addStyles = ({ theme }) => css`
  height: auto;
  padding: 42px;
  border-radius: ${theme.radii.article};
  display: flex;
  flex-wrap: wrap;
`;
